// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingThisMonthFeesResponse

export type BillingThisMonthFeesApiResponse = {
	paymentFees: number;
	guarantees: number;
	totalHt: number;
	tva: number;
	taxRate: number;
	collected: number;
	solde: number;
};

export type BillingThisMonthFees = {
	paymentFees: number;
	guarantees: number;
	totalHt: number;
	tva: number;
	taxRate: number;
	collected: number;
	solde: number;
};

export function hydrateBillingThisMonthFees(data: BillingThisMonthFeesApiResponse): BillingThisMonthFees {
	return { ...data };
}